import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {MenuTitleDescriptionModel} from '../views/models/menu-title-description.model';
import {Injectable} from '@angular/core';
import {RequestActionModel} from '../views/models/request-action.model';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestActionService {
  titleDescription_change$ = new BehaviorSubject<MenuTitleDescriptionModel>(new MenuTitleDescriptionModel());

  constructor(private httpClient: HttpClient) {
  }

  getTitleAndDescription(item_id, no) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/title_description/' + item_id + '/' + no).subscribe(
      (resp: MenuTitleDescriptionModel) => {
        this.titleDescription_change$.next(resp);
      }
    );
  }

  postRequestAction(data: RequestActionModel) {
    this.httpClient.post(environment.baseURL + '/v2/api' + '/request_action', data).subscribe(
      (resp) => {
        console.log(resp);
      }, (error => {
        console.log(error);
      })
    );
  }
}
